import React, { useState, useEffect } from "react";
import { format, isToday, isYesterday, parseISO } from "date-fns";
import { toZonedTime } from "date-fns-tz";

const LastActivityTimestamp = ({ createdAt }) => {
  const timeZone = "America/New_York";
  const [dateLabel, setDateLabel] = useState("");
  const [timeLabel, setTimeLabel] = useState("");

  useEffect(() => {
    if (!createdAt) return;

    const zonedDate = toZonedTime(parseISO(createdAt), timeZone);

    // Date part
    if (isToday(zonedDate)) {
      setDateLabel("Today");
    } else if (isYesterday(zonedDate)) {
      setDateLabel("Yesterday");
    } else {
      setDateLabel(format(zonedDate, "MMMM d, yyyy"));
    }

    // Time part
    setTimeLabel(format(zonedDate, "h:mm a"));
  }, [createdAt]);

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <span>{dateLabel}</span>
      <span>{timeLabel}</span>
    </div>
  );
};

export default LastActivityTimestamp;
